import React, { useState, useEffect } from 'react';
import { getLastDataUpdatedTime } from '../../services/patient';

export default function DateTimeDisplay(props) {
  const { account_id, location_id } = props;
  const [currentDateTime, setCurrentDateTime] = useState('');

  useEffect(() => {
    const fetchLastUpdatedTime = async (account_id, location_id) => {
      try {
        const response = await getLastDataUpdatedTime(account_id, location_id);
        if (response) {
          setCurrentDateTime(response);
        }
      } catch (error) {
        console.error("Error fetching last updated time:", error);
      }
    };
    fetchLastUpdatedTime(account_id, location_id);
  }, [account_id, location_id]);

  return (
    <div>
      <p className='mb-0'>Last Updated: {currentDateTime}</p>
    </div>
  );
};
